import { render, staticRenderFns } from "./politica-privacidade.vue?vue&type=template&id=1674d6ec&"
import script from "./politica-privacidade.vue?vue&type=script&lang=js&"
export * from "./politica-privacidade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports